import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { AppointmentDto } from 'src/app/shared/models/appointment/appointment-dto.model';

import { AppointmentDB } from '../../common/repository/databases';
import { WorkItem } from '../work-item';

@Injectable({ providedIn: 'root' })
export class AppointmentWorkItem extends WorkItem<AppointmentDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }

  get name(): string {
    return 'AppointmentWorkItem';
  }
  get database(): string {
    return AppointmentDB;
  }
}
